<template>
    <v-card>
        <v-toolbar flat color="primary" dark>
            <v-toolbar-title>
                <v-icon left>
                    {{ icon }}
                </v-icon>
                {{ title }}
            </v-toolbar-title>
        </v-toolbar>
        <v-card flat>
            <v-card-text>
                <v-row>
                    <v-col>
                        <v-select v-model="formula.valor" :items="valores" item-text="name" item-value="value"
                            label="Valor"></v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col v-if="search">
                        <v-text-field label="Dureza Mínima" type="number" clearable v-model="formula.mindureza" />
                    </v-col>
                    <v-col v-if="search">
                        <v-text-field label="Dureza Máxima" type="number" clearable v-model="formula.maxdureza" />
                    </v-col>
                    <v-col v-else>
                        <v-text-field label="Dureza" type="number" clearable v-model="formula.dureza" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="3" v-if="search">
                        <v-select v-model="formula.alargamiento_comparacion" :items="comparacion" item-text="name"
                            item-value="value">
                        </v-select>
                    </v-col>
                    <v-col>
                        <v-text-field label="Alargamiento" type="number" clearable v-model="formula.alargamiento"
                            suffix="%" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="3" v-if="search">
                        <v-select v-model="formula.carga_rot_mpa_comparacion" :items="comparacion" item-text="name"
                            item-value="value">
                        </v-select>
                    </v-col>
                    <v-col>
                        <v-text-field label="Carga Rot. MPA" type="number" clearable v-model="formula.carga_rot_mpa" />
                    </v-col></v-row>
                <v-row>
                    <v-col cols="3" v-if="search">
                        <v-select v-model="formula.desgarro_comparacion" :items="comparacion" item-text="name"
                            item-value="value">
                        </v-select>
                    </v-col>
                    <v-col>
                        <v-text-field label="Desgarro-B" type="number" clearable v-model="formula.desgarro" suffix="N/mm" />
                    </v-col></v-row>
                <v-row>
                    <v-col cols="3" v-if="search">
                        <v-select v-model="formula.c_set_comparacion" :items="comparacion" item-text="name"
                            item-value="value">
                        </v-select>
                    </v-col>
                    <v-col>
                        <v-text-field label="C-SET (22h 175ºC)" type="number" clearable v-model="formula.c_set"
                            suffix="ºC" />
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-card>
</template>

<script>
export default {
    props: {
        title: String,
        icon: String,
        formula: Object,
        search: Boolean,
    },
    data() {
        return {
            valores: [
                { name: "SILAM", value: "SILAM" },
                { name: "WACKER", value: "WACKER" },
                { name: "No definido", value: "-" },
            ],
            comparacion: [
                { name: ">", value: "gt" },
                { name: ">=", value: "gte" },
                { name: "==", value: "e" },
                { name: "<", value: "lt" },
                { name: "<=", value: "lte" },
            ],
        }
    }
}
</script>